const MeetingsTab = () => {
  return (
    <div>
      <h1>this is meetings tab</h1>
    </div>
  );
};

export default MeetingsTab;
